import { useEffect } from 'react';
import ParticleCanvas from './components/ParticleCanvas';
import Navigation from './sections/Navigation';
import Hero from './sections/Hero';
import SobreCriadora from './sections/SobreCriadora';
import VerixaWorld from './sections/VerixaWorld';
import Multimodal from './sections/Multimodal';
import ChatTerminal from './sections/ChatTerminal';
import Recursos from './sections/Recursos';
import ComoUsar from './sections/ComoUsar';
import Footer from './sections/Footer';
import { TabSwitcher } from './components/TabSwitcher';

function App() {
  // Smooth scroll via Lenis-style behavior (native)
  useEffect(() => {
    // Add lenis smooth scroll via CSS and native smooth behavior
    document.documentElement.style.scrollBehavior = 'smooth';

    // Prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.documentElement.style.scrollBehavior = 'auto';
    }

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="relative min-h-screen" style={{ background: '#050505' }}>
      {/* Global Particle Canvas - sits behind content */}
      <ParticleCanvas level="impacto" />

      {/* Navigation */}
      <Navigation />

      {/* Tab Switcher - Wraps Vérixa (Aba 1) and Aurora (Aba 2) */}
      <TabSwitcher
        verixa={
          <main className="relative" style={{ zIndex: 2 }}>
            <Hero />
            <SobreCriadora />
            <VerixaWorld />
            <Multimodal />
            <ChatTerminal />
            <ComoUsar />
            <Recursos />
            <Footer />
          </main>
        }
      />
    </div>
  );
}

export default App;
